import React from 'react';
import { Form, Input, Button, notification } from 'antd';


const AuthForm = (props) => {

    const { setIsAuth }= props;

    const layout = {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
    };

    const tailLayout = {
        wrapperCol: { offset: 8, span: 16 },
    };

    const onFinish = (values) => {
        console.log('Success:', values);
        const { email, password } = values;
        if(email === "rdeleon@planbsys.com" && password === "11!b$23%!a"){
            notification["success"]({
                message: "Bienvenido."
            })
            setIsAuth(true);
        } else {
            notification["error"]({
                message: "No tiene permiso."
            })
        }
    };

    return (
        <Form
            {...layout}
            name="basic"
            onFinish={onFinish}
        >
        <Form.Item
            label="Email"
            name="email"
            rules={[
                {
                    type: 'email',
                    required: true,
                    message: 'Ingrese un email válido!',
                },
                ]}
        >
            <Input />
        </Form.Item>

        <Form.Item
            label="Contraseña"
            name="password"
            rules={[
            {
                required: true,
                message: 'Ingrese una contraseña!',
            },
            ]}
        >
            <Input.Password />
        </Form.Item>

        <Form.Item {...tailLayout}>
            <Button type="primary" htmlType="submit">
                Enviar
            </Button>
        </Form.Item>
        </Form>
    )
}

export default AuthForm;
